﻿import { createContext, useState, useMemo } from "react";

export const initFacilitySearchContext = {
    country: document.querySelector("html").getAttribute("country"),
    showLoadingScreen: true,
    init: true,
    searchDate: null,
    selectedLocation: null,
    returnToOriginalPosition: false,
    lastKnownLocation: null,
    filtersOpen: false,
    updateMarkers: true,
    filterSelection: {
        LTP: false,
        STP: false,
        Indoor: false,
        Outdoor: false,
        Heated: false,
        MaxVehicleHeight: false,
        disabled: false,
        electricChargingPoint: false,
        ParkingSpaceTypeSelection: {},
    },
    mapViewOpen: false,
    mapElementInDom: null,
    mapPosition: null,
    mapZoom: 15,
    mapBounds: null,
    updateMapBounds: false,
    allFacilities: null,
    filteredFacilities: null,
    visibleFacilities: null,
    panOnLoad: true,
    focusedFacility: null,
    filterOnInit: false,
    showOnMap: null,
};

export const FacilitySearchContext = createContext(null);

export const FacilitySearchContextProvider = (props) => {
    const initContext = initFacilitySearchContext;

    const [facilitySearchContext, setFacilitySearchContextTmp] =
        useState(initContext);

    const setFacilitySearchContext = (state) => {
        setFacilitySearchContextTmp(state);
    };

    const facilitySearchState = useMemo(
        () => ({ facilitySearchContext, setFacilitySearchContext }),
        [facilitySearchContext, setFacilitySearchContext],
    );

    return (
        <FacilitySearchContext.Provider value={facilitySearchState}>
            {props.children}
        </FacilitySearchContext.Provider>
    );
};

const UserLocation = () => {
    if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition((position) => {
            return {
                lat: position.coords.latitude,
                lng: position.coords.longitude,
            };
        });
    } else {
        return {
            lat: null,
            lng: null,
        };
    }
};
